const menu = {
  key: "zipCodes",
  route: "/legacy/zip-codes",
  label: "sidebar.zipCodes",
  icon: "faLocationDot",
  group: "masterdata",
  order: 50,
  permission: "legacy.zipCodes.read"
};

export default menu;